<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="toolbar-filter-bar">
        <el-form :inline="true" :model="filters" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="分组">
              <el-select v-model="filters.groupId" clearable placeholder="全部" class="toolbar-field-w-md"
                @change="onGroupChange">
                <el-option v-for="g in groupOptions" :key="g.Id" :label="g.GroupName" :value="g.Id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="班牌">
              <el-select v-model="filters.terminalDbId" clearable filterable placeholder="全部" class="toolbar-field-w-lg">
                <el-option v-for="t in terminalOptions" :key="t.Id"
                  :label="formatTerminalLabel(t)" :value="t.Id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间段">
              <el-select v-model="filters.timeSlotId" clearable placeholder="全部" class="toolbar-field-w-slot">
                <el-option v-for="s in slotOptions" :key="s.Id"
                  :label="formatTeacherPatrolSlotLabel(s)" :value="s.Id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="轮次">
              <el-select v-model="filters.roundNumber" clearable placeholder="全部" class="toolbar-field-w-md">
                <el-option v-for="n in roundFilterOptions" :key="n" :label="'第' + n + '次'" :value="n"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="教师">
              <el-input v-model="filters.teacherName" clearable placeholder="姓名" class="toolbar-field-w-md"
                @keyup.enter.native="handleQuery"></el-input>
            </el-form-item>
            <el-form-item label="日期">
              <el-date-picker v-model="filters.dateRange" type="daterange" value-format="yyyy-MM-dd"
                start-placeholder="开始" end-placeholder="结束" class="toolbar-field-w-daterange"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button v-for="item in actionButtonList" :key="item.id || item.Func"
              size="small"
              :type="toolbarBtnType(item)"
              :icon="toolbarBtnIcon(item)"
              :loading="!!item.loading"
              @click="btnClick(item)">{{ item.name }}</el-button>
          </div>
        </el-form>
      </div>

            <el-table :data="users" v-loading="listLoading" style="width: 100%;" stripe>
        <el-table-column prop="GroupName" label="分组" min-width="100" align="center" header-align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="SlotName" label="时间段" min-width="90" align="center" header-align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="TerminalId" label="班牌标识" min-width="100" align="center" header-align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="TerminalName" label="班牌名称" min-width="110" align="center" header-align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="DepartmentName" label="班级" min-width="100" align="center" header-align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="TeacherName" label="教师" min-width="90" align="center" header-align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="第几次" width="80" align="center" header-align="center">
          <template slot-scope="scope">
            <el-tag size="mini" type="info">第{{ scope.row.RoundNumber }}次</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="登记日期" width="110" align="center" header-align="center">
          <template slot-scope="scope">{{ formatDate(scope.row.RegisterDate) }}</template>
        </el-table-column>
        <el-table-column label="登记时间" min-width="160" align="center" header-align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ formatDateTime(scope.row.RegisterTime) }}</template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
          :current-page="page" :page-size="pageSize" :total="total" style="float: right"></el-pagination>
      </div>
    </section>
  </section>
</template>

<script>
import {
  getTeacherPatrolRecordPage,
  exportTeacherPatrolRecord,
  getTeacherPatrolGroupOptions,
  getTeacherPatrolTimeSlotOptions,
  getTeacherPatrolTerminalOptions,
  formatTeacherPatrolSlotLabel,
  clearTeacherPatrolListTable,
  onTeacherPatrolSchoolChange
} from "@/api/teacherPatrol";
import { treeNodeDeptId } from '../../utils/deptCascaderProps';
import { getButtonList } from "../../promissionRouter";
import DepartmentPane from "../../components/DepartmentPane";
import toolbarFilterBarMixin from "@/mixins/toolbarFilterBarMixin";

function todayStr() {
  const today = new Date();
  return today.getFullYear() + "-" +
    String(today.getMonth() + 1).padStart(2, "0") + "-" +
    String(today.getDate()).padStart(2, "0");
}

export default {
  mixins: [toolbarFilterBarMixin],
  components: { DepartmentPane },
  data() {
    const today = todayStr();
    return {
      filters: {
        groupId: null,
        terminalDbId: null,
        teacherName: "",
        timeSlotId: null,
        roundNumber: null,
        dateRange: [today, today]
      },
      actionButtonList: [],
      users: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      DepartmentId: 0,
      groupOptions: [],
      terminalOptions: [],
      slotOptions: [],
      roundFilterOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9]
    };
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    const buttonList = getButtonList(this.$route.path, routers);
    // 查询按钮已在筛选区固定展示，避免与权限按钮重复
    this.actionButtonList = buttonList.filter(b => b.Func !== "handleQuery");
    this.applyRouteQuery();
  },
  methods: {
    formatTeacherPatrolSlotLabel,
    applyRouteQuery() {
      const q = this.$route.query || {};
      if (q.groupId) this.filters.groupId = Number(q.groupId);
      if (q.timeSlotId) this.filters.timeSlotId = Number(q.timeSlotId);
      if (q.registerDate) this.filters.dateRange = [q.registerDate, q.registerDate];
      if (q.roundNumber) this.filters.roundNumber = Number(q.roundNumber);
    },
    formatTerminalLabel(t) {
      const name = t.TerminalName || t.TerminalId || "";
      const dept = t.DepartmentName ? "（" + t.DepartmentName + "）" : "";
      return name + dept;
    },
    formatDate(val) {
      if (!val) return "";
      return String(val).substring(0, 10);
    },
    formatDateTime(val) {
      if (!val) return "";
      return String(val).replace("T", " ").substring(0, 19);
    },
    btnClick(item) {
      if (item.Func && typeof this[item.Func] === "function") {
        this[item.Func](item);
      }
    },
    async treeNodeClick(data) {
      onTeacherPatrolSchoolChange(this, treeNodeDeptId(data));
      await this.loadFilterOptions();
      this.handleQuery();
    },
    async loadFilterOptions() {
      if (!this.DepartmentId) {
        clearTeacherPatrolListTable(this);
        return;
      }
      const [groupRes, slotRes] = await Promise.all([
        getTeacherPatrolGroupOptions({ departmentId: this.DepartmentId }),
        getTeacherPatrolTimeSlotOptions({ departmentId: this.DepartmentId })
      ]);
      this.groupOptions = groupRes.data.success ? (groupRes.data.response || []) : [];
      this.slotOptions = slotRes.data.success ? (slotRes.data.response || []) : [];
      this.syncFilterSelections();
      await this.loadTerminalOptions();
    },
    syncFilterSelections() {
      if (this.filters.groupId) {
        const groupIds = this.groupOptions.map(g => g.Id);
        if (groupIds.indexOf(this.filters.groupId) < 0) {
          this.filters.groupId = null;
        }
      }
      if (this.filters.timeSlotId) {
        const slotIds = this.slotOptions.map(s => s.Id);
        if (slotIds.indexOf(this.filters.timeSlotId) < 0) {
          this.filters.timeSlotId = null;
        }
      }
    },
    async onGroupChange() {
      this.filters.terminalDbId = null;
      await this.loadTerminalOptions();
    },
    async loadTerminalOptions() {
      if (!this.DepartmentId) {
        this.terminalOptions = [];
        return;
      }
      const res = await getTeacherPatrolTerminalOptions({ departmentId: this.DepartmentId });
      if (res.data.success) {
        this.terminalOptions = res.data.response || [];
      } else {
        this.terminalOptions = [];
      }
      if (this.filters.terminalDbId) {
        const terminalIds = this.terminalOptions.map(t => t.Id);
        if (terminalIds.indexOf(this.filters.terminalDbId) < 0) {
          this.filters.terminalDbId = null;
        }
      }
    },
    buildQueryParams() {
      const para = {
        departmentId: this.DepartmentId,
        groupId: this.filters.groupId || 0,
        terminalDbId: this.filters.terminalDbId || 0,
        timeSlotId: this.filters.timeSlotId || 0,
        teacherName: this.filters.teacherName || ""
      };
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        para.startDate = this.filters.dateRange[0];
        para.endDate = this.filters.dateRange[1];
      }
      if (this.filters.roundNumber) {
        para.roundNumber = this.filters.roundNumber;
      }
      return para;
    },
    handleQuery() {
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    async getList() {
      if (!this.DepartmentId) {
        clearTeacherPatrolListTable(this);
        return;
      }
      this.listLoading = true;
      try {
        const para = { ...this.buildQueryParams(), page: this.page, intPageSize: this.pageSize };
        const res = await getTeacherPatrolRecordPage(para);
        if (res.data.success) {
          this.users = res.data.response.data || [];
          this.total = res.data.response.dataCount || 0;
        } else {
          clearTeacherPatrolListTable(this);
        }
      } finally {
        this.listLoading = false;
      }
    },
    async exportExcel() {
      if (!this.DepartmentId) {
        this.$message.warning("请先选择学校");
        return;
      }
      try {
        const res = await exportTeacherPatrolRecord(this.buildQueryParams());
        const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "教师巡检登记明细_" + new Date().getTime() + ".xlsx";
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        this.$message.error("导出失败");
      }
    }
  }
};
</script>

<style scoped>
.pagination-container {
  margin-top: 16px;
  overflow: hidden;
}
</style>
